import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import store from "./store/index";

const resources = {
  en: {
    translation: {
      "AR1": "Are you a company user?",
      "AR2": "Are you an Individual User ?",
      "IR1": "Individual Registration",
      "IR2": "Individual users can register here in three simple steps. Registration requires OTP validation.",
      "CR1": "Company Registration",
      "CR2": "Company Register",
      "LN1": "Login",
      "LN2": "Registered Users can login using mobile number/username",
      "LN3": "Mobile Number/ Username",
      "LN4": "Please enter your Mobile number or  login username",
      "LN5": "Password",
      "LN6": "Please enter password      ",
      "LN7": "Forgot Password?",
      "DS1": "Welcome to MOSA Online Booking Portal",
      "DS2": "INTRODUCTION",
      "DS3": "Individual users can now apply for membership at various MOSA facilities and make use of the world class amenties",
      "DS4": "Please select your desired MOSA facility and apply.",
      "DS5": "Previous",
      "DS6": "Next",
      "DS7": "Apply for Membership",
      "DS8": "BOOK NOW",
      "HR1": "START",
      "HR2": "PRICING",
      "HR3": "CONTACT US",
      "HR4": "Membership",
      "HR5": "Create Event",
      "HR6": "My Account",
      "HR7": "Login Now",
      "JK1": "Are you a company user?",
      "JK2": "Are you an Individual User ?",
      "JK3": "Individual Registration",
      "JK4": "Individual users can register here in three simple steps. Registration requires OTP validation.",
      "JK5": "Company Registration",
      "JK6": "Company Register",
      "JK7": "Login",
      "JK8": "Registered Users can login using mobile number/username",
      "JK9": "Mobile Number/ Username",
      "JK10": "Please enter your Mobile number or  login username",
      "JK11": "Password",
      "JK12": "Please enter password",
      "JK13": "Forgot Password?",
      "JK14": "Welcome to MOSA Online Booking Portal",
      "JK15": "INTRODUCTION",
      "JK16": "Users can now apply for membership in many of the Sultan Qaboos Sports Complex facilities to exercise",
      "JK17": "Please select your desired MOSA facility and apply.",
      "JK18": "Previous",
      "JK19": "Next",
      "JK20": "Apply for Membership",
      "JK21": "BOOK NOW",
      "JK22": "START",
      "JK23": "PRICING",
      "JK24": "CONTACT US",
      "JK25": "Membership",
      "JK26": "Create Event",
      "JK27": "My Account",
      "JK28": "Login Now",
      "JK29": "My Bookings",
      "JK30": "Welcome ,",
      "JK31": "Email :",
      "JK32": "Phone :",
      "JK33": "Company User",
      "JK34": "Create New Event",
      "JK35": "Corporate users can now create events on MOSA facilities.",
      "JK36": "My Account",
      "JK37": "You Can View Membership Request , Event Booking Request And Other Profile Details.",
      "JK38": "Pending Approval",
      "JK39": "Your request is pending approval from MOSA admin. You can edit the list of facilities till the request is approved.",
      "JK40": "Event Name",
      "JK41": "Event Description",
      "JK42": "Stadium Name",
      "JK43": "Start Date",
      "JK44": "End Date",
      "JK45": "Facility/Requirement",
      "JK46": "Total Hours",
      "JK47": "Rate",
      "JK48": "Total Price",
      "JK49": "Make Payment",
      "JK50": "Delete Event",
      "JK51": "Create Event",
      "JK52": "Create Your Event Utilizing MOSA Facilities",
      "JK53": "Step 1 - Add Event Details",
      "JK54": "Step 2 - Add facility for the event",
      "JK55": "Step 3 - Review and Submit",
      "JK56": "Select Event Type",
      "JK57": "Event Description(max 200 characters)",
      "JK58": "Select Location",
      "JK59": "Select Stadium",
      "JK60": "SELECT FACILITY",
      "JK61": "ENTER TITLE",
      "JK62": "START TIME",
      "JK63": "END TIME",
      "JK64": "PARTICIPANTS COUNT",
      "JK65": "HOURLY RATE",
      "JK66": "TOTAL COST",
      "JK67": "Add Venue",
      "JK68": "No Venues selected",
      "JK69": "Please search available venues and add to your event",
      "JK70": "Total Amount :",
      "JK71": "Registered Users Can Login Using Mobile Number/Username",
      "JK72": "Please Submit The Medical Certificate And ID Proof",
      "JK73": "Medical Certificate",
      "JK74": "Please submit recent medical certificate from authorized clinic",
      "JK75": "ID Proof",
      "JK76": "Please submit your ID proof",
      "JK77": "Upload medical Certificate",
      "JK78": "Upload ID Proof",
      "JK79": "Facility Membership",
      "JK80": "Please apply for membership in three simple steps.",
      "JK81": "About US",
      "JK82": "Contact Details",
      "JK83": "Please enter your login name",
      "JK84": "Please enter Password",
      "JK85": "Please confirm Password",
      "JK86": "Passwords do not match",
      "JK87": "Please enter Company Name",
      "JK88": "Please enter Company Name",
      "JK89": "Please enter Company Address",
      "JK90": "Please enter CR Number",
      "JK91": "Please attach Company Documents",
      "JK92": "Your membership request is submitted",
      "JK93": "Please try again later!!!!",
      "JK94": "Error",
      "JK95": "Success",
      "JK96": "Register",
      "JK97": "Companies and Individuals can register to avial MOSA facilities",
      "JK98": "Company Registration",
      "JK99": "Corporate users can register here.",
      "JK100": "Individual Registration",
      "JK101": "Are you an Individual User ?",
      "JK102": "Individual Register",
      "JK103": "Step 1. Add Login Details",
      "JK104": "Login Name",
      "JK105": "Please enter your login username",
      "JK106": "Step 2. Add Company Details",
      "JK107": "Confirm Password",
      "JK108": "Company Name",
      "JK109": "Please enter your company name",
      "JK110": "Please enter your company email",
      "JK111": "Please enter your company Registration Number",
      "JK112": "Please enter your company contact number",
      "JK113": "Please enter your company address",
      "JK114": "Company Email",
      "JK115": "Company CR Number",
      "JK116": "Company Contact",
      "JK117": "Company Address",
      "JK118": "Select Company Type",
      "JK119": "Company Document",
      "JK120": "Please upload company document",
      "JK121": "Step 3. Review and Submit",
      "JK122": "Submit",
      "JK123": "Membership not Completed",
      "JK124": "Please wait for the membership request to be approved",
      "JK125": "Please complete Step 1 and Step 2 to proceed to Payment",
      "JK126": "Please enter your name",
      "JK127": "Please enter Date of Birth",
      "JK128": "Please enter Occupation",
      "JK129": "Please enter Civil ID/Passport",
      "JK130": "Please enter Residence Place",
      "JK131": "Your membership request is submitted",
      "JK132": "Please try again later!",
      "JK133": "Please select location!",
      "JK134": "Please select stadium!",
      "JK135": "Please select Membership Type!",
      "JK136": "Please select duration!",
      "JK137": "Your medical document has been submitted",
      "JK138": "Please attach a valid Medical Certificate",
      "JK139": "Your  document ID Proof has been submitted",
      "JK140": "Please submit the medical certificate and ID proof",
      "JK141": "Complete membership to access MOSA facilities",
      "JK142": "Facility  Membership",
      "JK143": "Please apply for membership in three simple steps.",
      "JK144": "Membership Form",
      "JK145": "Please submit details for Membership",
      "JK146": "Your membership form is submitted successfully. Please upload the support documents in Step 2",
      "JK147": "Select your location",
      "JK148": "Select Location",
      "JK149": "Select your Stadium/Facility",
      "JK150": "Select Stadium",
      "JK151": "Select membership type",
      "JK152": "Select Membership Type",
      "JK153": "Select Membership Duration",
      "JK154": "Half year",
      "JK155": "Full year",
      "JK156": "Total Membership Cost :",
      "JK157": "Mobile Number",
      "JK158": "Name",
      "JK159": "Occupation",
      "JK160": "Nationality",
      "JK161": "Omani",
      "JK162": "Non-Omani",
      "JK163": "Civil ID/ Passport Number",
      "JK164": "Enter Civil ID/ Passport",
      "JK165": "Date of Birth",
      "JK166": "Enter Date of birth",
      "JK167": "Gender",
      "JK168": "Male",
      "JK169": "Female",
      "JK170": "Work Place",
      "JK171": "Enter Work Place",
      "JK172": "Locality",
      "JK173": "Enter your Locality",
      "JK174": "Submit Details",
      "JK175":"You have not made any bookings.",
      "JK176":"Event Type",
      "JK177":"Event Summary",
      "JK178":"Facilities Summary",
      "JK179":"Venue",
      "JK180":"Sub Total",
      "JK181":"Taxes",
      "JK182":"Set Password",
      "JK183":"Company Type",
      "JK200":"Sultan Qaboos Sport Complex",
      "JK201":"Popular Venues",
      "JK202":"Please enter Name",
      "JK203":"Please enter Mobile Number",
      "JK204":"Please enter Email",
      "JK205":"Resend OTP",
      "JK206":"Gym",
      "JK207":"Swimming Pool",
      "JK208":"Athletics Track",
      "JK209":"Football",
      "JK210":"Step 2. Validate OTP",
      "JK211":"Enter OTP Received in your mobile",
      "JK212":"Enter OTP",
      "JK213":"Step 3. Set Password",
      "JK214":"Please set password",
      "JK215":"Medical Certificate Uploaded",
      "JK216":"Your medical certificate is uploaded successfully",
      "JK226":"Hockey Field",
      "JK227":"Event Details",
      "JK228":"Your Request is Approved",
      "JK229":"Please make payment to complete the request ",
      "JK230":"View",

    }
  },
  ar: {
    translation: {
      "AR1": "هل أنت مستخدم شركة؟ ",
      "AR2": "هل أنت مستخدم فردي؟      ",
      "IR1": "التسجيل الفردي      ",
      "IR2": "يمكن للمستخدمين الأفراد التسجيل هنا في ثلاث خطوات بسيطة. يتطلب التسجيل التحقق من صحة OTP.",
      "CR1": "تسجيل الشركة      ",
      "CR2": "تسجيل شركة      ",
      "LN1": "تسجيل الدخول ",
      "LN2": "يمكن للمستخدمين المسجلين تسجيل الدخول باستخدام رقم الهاتف المحمول / اسم المستخدم      ",
      "LN3": "رقم الهاتف / اسم المستخدم      ",
      "LN4": "الرجاء إدخال رقم هاتفك المحمول أو اسم المستخدم لتسجيل الدخول      ",
      "LN5": "كلمه السر      ",
      "LN6": "الرجاء إدخال كلمة المرور      ",
      "LN7": "هل نسيت كلمة المرور؟      ",
      "DS1": "مرحبًا بكم في بوابة الحجز عبر الإنترنت لوزارة الشؤون الاجتماعية      ",
      "DS2": "المقدمة      ",
      "DS3": "يمكن للمستخدمين الفرديين الآن التقدم بطلب للحصول على عضوية في العديد من مرافق وزارة الشؤون الاجتماعية والاستفادة من وسائل الراحة العالمية      ",
      "DS4": "يرجى تحديد مرفق وزارة الشؤون الاجتماعية الذي تريده والتقدم بطلب.      ",
      "DS5": "السابق",
      "DS6": "التالى      ",
      "DS7": "تقدم بطلب العضوية      ",
      "DS8": "احجز الآن",
      "HR1": "بداية      ",
      "HR2": "التسعير      ",
      "HR3": "اتصل بنا      ",
      "HR4": "عضوية      ",
      "HR5": "انشاء حدث      ",
      "HR6": "حسابي      ",
      "HR7": "تسجيل الدخول الآن      ",
      "JK1": "هل أنت مستخدم شركة؟",
      "JK2": "هل أنت مستخدم فردي؟",
      "JK3": "التسجيل الفردي",
      "JK4": "يمكن للمستخدمين الفرديين الآن التقدم بطلب للحصول على عضوية في العديد من مرافق وزارة الثقافة والرياضة والشباب      ",
      "JK5":  "تسجيل المؤسسة",
      "JK6": "تسجيل المؤسسة",
      "JK7": "تسجيل الدخول",
      "JK8": "يمكن للمستخدمين المسجلين تسجيل الدخول باستخدام رقم الهاتف المحمول / اسم المستخدم",
      "JK9": "رقم الهاتف / اسم المستخدم",
      "JK10": "الرجاء إدخال رقم هاتفك المحمول أو اسم المستخدم لتسجيل الدخول",
      "JK11": "كلمه السر",
      "JK12": "الرجاء إدخال كلمة المرور",
      "JK13": "هل نسيت كلمة المرور؟",
      "JK14": "مرحبًا بكم في بوابة الحجز عبر الإنترنت لوزارة الثقافة والرياضة والشباب      ",
      "JK15": "المقدمة",
      "JK16": "يمكن للمستخدمين الان التقدم بطلب عضوية  في للعديد من مرافق مجمع السلطان قابوس الرياضي لممارسة الرياضة",
      "JK17": "يرجى تحديد مرفق وزارة الثقافة والرياضة والشباب الذي تريده والتقدم بطلب.",
      "JK18": "السابق",
      "JK19": "التالى",
      "JK20": "تقدم بطلب العضوية",
      "JK21": "احجز الآن",
      "JK22": "بداية",
      "JK23": "التسعير",
      "JK24": "اتصل بنا",
      "JK25": "عضوية",
      "JK26": "انشاء حدث",
      "JK27": "حسابي",
      "JK28": "تسجيل الدخول الآن",
      "JK29": "حجوزاتي",
      "JK30": "أهلا بك ،",
      "JK31": "البريد الإلكتروني :",
      "JK32": "هاتف :",
      "JK33": "مستخدم الشركة",
      "JK34": "إنشاء حدث جديد",
      "JK35": "يمكن لمستخدمي الشركات الآن إنشاء أحداث على مرافق وزارة الثقافة والرياضة والشباب",
      "JK36": "حسابي",
      "JK37": "يمكنك عرض طلب العضوية وطلب حجز الحدث وتفاصيل الملف الشخصي الأخرى.",
      "JK38": "ما زال يحتاج بتصدير",
      "JK39": "طلبك في انتظار الموافقة من مسؤول وزارة الشؤون الاجتماعية. يمكنك تعديل قائمة التسهيلات حتى تتم الموافقة على الطلب.",
      "JK40": "اسم الحدث",
      "JK41": "وصف الحدث",
      "JK42": "اسم الملعب",
      "JK43": "تاريخ البدء",
      "JK44": "تاريخ الانتهاء",
      "JK45": "المتطلبات / المرفق ",
      "JK46": "مجموع الساعات",
      "JK47": "معدل",
      "JK48": "السعر الكلي",
      "JK49": "قم بالدفع",
      "JK50": "حذف الحدث",
      "JK51": "انشاء حدث",
      "JK52": "أنشئ حدثك باستخدام مرافق وزارة الثقافة والرياضة والشباب",
      "JK53": "الخطوة 1 - إضافة تفاصيل الحدث",
      "JK54": "الخطوة 2 - أضف وسيلة للحدث",
      "JK55": "الخطوة 3 - المراجعة والإرسال",
      "JK56": "حدد نوع الحدث",
      "JK57": "وصف الحدث (200 حرف كحد أقصى)",
      "JK58": "اختر موقعا",
      "JK59": "حدد الملعب",
      "JK60": "اختر المنشأة",
      "JK61": "أدخل العنوان",
      "JK62": "وقت البدء",
      "JK63": "وقت النهاية",
      "JK64": "عدد المشاركين",
      "JK65": "المعدل بالساعة",
      "JK66": "التكلفة الإجمالية",
      "JK67": "إضافة مكان",
      "JK68": "لم يتم اختيار أماكن",
      "JK69": "يرجى البحث عن الأماكن المتاحة والإضافة إلى الحدث الخاص بك",
      "JK70": "المبلغ الإجمالي :",
      "JK71": "يمكن للمستخدمين المسجلين تسجيل الدخول باستخدام رقم الهاتف المحمول / اسم المستخدم",
      "JK72": "يرجى تقديم الشهادة الطبية وإثبات الهوية",
      "JK73": "شهادة طبية",
      "JK74": "يرجى تقديم شهادة طبية حديثة من عيادة معتمدة",
      "JK75": "إثبات الهوية",
      "JK76": "يرجى تقديم إثبات الهوية الخاصة بك",
      "JK77": "تحميل الشهادة الطبية",
      "JK78": "إثبات الهوية",
      "JK79": "عضوية المنشأة",
      "JK80": "يرجى التقدم بطلب للحصول على العضوية بثلاث خطوات بسيطة.",
      "JK81": "معلومات عنا",
      "JK82": "بيانات المتصل",
      "JK83": "الرجاء إدخال اسم تسجيل الدخول الخاص بك",
      "JK84": "الرجاء إدخال كلمة المرور",
      "JK85": "الرجاء تأكيد كلمة المرور",
      "JK86": "كلمة المرور غير مطابقة",
      "JK87": "الرجاء إدخال اسم المؤسسة",
      "JK88": "الرجاء إدخال اسم المؤسسة",
      "JK89": "الرجاء إدخال عنوان المؤسسة",
      "JK90": "الرجاء إدخال رقم السجل التجاري",
      "JK91": "يرجى إرفاق مستندات الشركة",
      "JK92": "تم تقديم طلب عضويتك",
      "JK93": "الرجاء معاودة المحاولة في وقت لاحق!!!!",
      "JK94": "خطأ",
      "JK95": "نجاح",
      "JK96": "تسجيل",
      "JK97": "يمكن للشركات والأفراد التسجيل في مرافق وزارة الشؤون الاجتماعية",
      "JK98": "تسجيل المؤسسة",
      "JK99": "يمكن لمستخدمي المؤسسات التسجيل هنا.",
      "JK100": "التسجيل الفردي",
      "JK101": "هل أنت مستخدم فردي؟",
      "JK102": "التسجيل الفردي",
      "JK103": "الخطوة 1. إضافة تفاصيل تسجيل الدخول",
      "JK104": "اسم الدخول",
      "JK105": "الرجاء إدخال اسم المستخدم الخاص بتسجيل الدخول",
      "JK106": "الخطوة 2. إضافة تفاصيل الشركة",
      "JK107": "تأكيد كلمة المرور",
      "JK108": "اسم الشركة",
      "JK109": "يرجى إدخال اسم المؤسسة الخاصة بك",
      "JK110": "الرجاء إدخال البريد الإلكتروني لمؤسستك",
      "JK111": "الرجاء إدخال رقم تسجيل مؤسستك",
      "JK112": "الرجاء إدخال رقم الاتصال مؤسستك",
      "JK113": "الرجاء إدخال عنوان مؤسستك",
      "JK114": "البريد الإلكتروني للمؤسسة",
      "JK115": "رقم السجل التجاري للمؤسسة",
      "JK116": "جهة اتصال المؤسسة",
      "JK117": "عنوان المؤسسة",
      "JK118": "حدد نوع المؤسسة",
      "JK119": "وثيقة المؤسسة",
      "JK120": "الرجاء تحميل وثيقة المؤسسة",
      "JK121": "الخطوة 3. المراجعة والإرسال",
      "JK122": "إرسال",
      "JK123": "العضوية غير مكتملة",
      "JK124": "يرجى انتظار الموافقة على طلب العضوية",
      "JK125": "يرجى إكمال الخطوتين 1 و 2 لمتابعة الدفع",
      "JK126": "من فضلك أدخل إسمك",
      "JK127": "الرجاء إدخال تاريخ الميلاد",
      "JK128": "الرجاء إدخال المهنة",
      "JK129": "الرجاء إدخال الرقم المدني / جواز السفر",
      "JK130": "الرجاء إدخال مكان الإقامة",
      "JK131": "تم تقديم طلب عضويتك",
      "JK132": "الرجاء معاودة المحاولة في وقت لاحق!",
      "JK133": "الرجاء تحديد الموقع!",
      "JK134": "الرجاء تحديد الملعب!",
      "JK135": "الرجاء تحديد نوع العضوية!",
      "JK136": "الرجاء تحديد المدة!",
      "JK137": "تم تقديم المستند الطبي الخاص بك",
      "JK138": "يرجى إرفاق شهادة طبية صالحة",
      "JK139": "تم تقديم إثبات معرف المستند الخاص بك",
      "JK140": "يرجى تقديم الشهادة الطبية وإثبات الهوية",
      "JK141": "عضوية كاملة للوصول إلى مرافق وزارة الثقافة والرياضة والشباب",
      "JK142": "عضوية المنشأة",
      "JK143": "يرجى التقدم بطلب للحصول على العضوية بثلاث خطوات بسيطة.",
      "JK144": "استمارة العضوية",
      "JK145": "يرجى تقديم تفاصيل العضوية",
      "JK146": "تم تقديم نموذج عضويتك بنجاح. يرجى تحميل مستندات الدعم في الخطوة 2",
      "JK147": "حدد موقعك",
      "JK148": "اختر موقعا",
      "JK149": "حدد الملعب / المنشأة الخاصة بك",
      "JK150": "حدد الملعب",
      "JK151": "حدد نوع العضوية",
      "JK152": "حدد نوع العضوية",
      "JK153": "حدد مدة العضوية",
      "JK154": "نصف سنة",
      "JK155": "عام كامل",
      "JK156": "إجمالي تكلفة العضوية:",
      "JK157": "رقم الهاتف المحمول",
      "JK158": "اسم",
      "JK159": "الوظيفة",
      "JK160": "الجنسية",
      "JK161": "عماني",
      "JK162": "غير عماني",
      "JK163": "البطاقة المدنية / رقم جواز السفر",
      "JK164": "أدخل الرقم المدني / جواز السفر",
      "JK165": "تاريخ الولادة",
      "JK166": "أدخل تاريخ الميلاد",
      "JK167": "جنس",
      "JK168": "الذكر",
      "JK169": "أنثى",
      "JK170": "مكان العمل",
      "JK171": "أدخل مكان العمل",
      "JK172": "المنطقة",
      "JK173": "أدخل منطقتك",
      "JK174": "إرسال التفاصيل",
      "JK175":"لم تقم بأي حجوزات.      ",
      "JK176":"نوع الحدث      ",
      "JK177":"ملخص الحدث      ",
      "JK178":"ملخص المرافق      ",
      "JK179":"مكان",
      "JK180":"المجموع الفرعي      ",
      "JK181":"Taxes",
      "JK182":"ضبط كلمة السر      ",
      "JK183":"نوع المؤسسة      ",
      "JK200":"مجمع السلطان قابوس الرياضي      ",
      "JK201":"الأماكن الشعبية      ",
      "JK202":"الرجاء إدخال الاسم      ",
      "JK203":"الرجاء إدخال رقم الجوال      ",
      "JK204":"الرجاء إدخال البريد الإلكتروني      ",
      "JK205":"إعادة إرسال OTP      ",
      "JK206":"نادي رياضي      ",
      "JK207":"حمام السباحة      ",
      "JK208":"مضمار اللياقة البدنية      ",
      "JK209":"كرة القدم      ",
      "JK210":"الخطوة 2. التحقق من صحة OTP      ",
      "JK211":"أدخل OTP المستلم في هاتفك المحمول      ",
      "JK212":"أدخل OTP      ",
      "JK213":"الخطوة 3. تعيين كلمة المرور      ",
      "JK214":"يرجى تعيين كلمة المرور      ",
      
      "JK215":"تم تحميل الشهادة الطبية      ",
      "JK216":"تم تحميل شهادتك الطبية بنجاح      ",
      "JK226":"هوكي فيلد      ",
      "JK227":"تفاصيل الحدث      ",
      "JK228":"تمت الموافقة على طلبك      ",
      "JK229":"يرجى تسديد المبلغ لإكمال الطلب      ",
      "JK230":"رأي      ",

    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: store.getState().lang,
    fallbackLng: 'en'
  });

export default i18n;